/**
 * Single source of truth for the "unclassifiable" industry-code sentinels.
 *
 * These are not real NAICS classifications — they are applied when a risk
 * cannot be classified: `9999` (4-digit OCR/system sentinel) and `999990`
 * ("Unclassified Establishments"). A submission carrying either value is
 * guaranteed to decline as "industry not supported".
 */
export const UNCLASSIFIABLE_INDUSTRY_CODES = ['9999', '999990'] as const;

/**
 * User-facing copy shown when a broker enters or keeps an unclassifiable
 * industry code on a manual-entry path — the submission cannot proceed.
 */
export const UNSUPPORTED_INDUSTRY_CODE_MESSAGE =
  "This industry code isn't supported and the submission can't proceed. Choose a supported industry code to continue.";

/**
 * Returns true only for the unclassifiable sentinels. Blank/undefined is not
 * unclassifiable (it is a separate "missing" condition), and every supported
 * code returns false. Tolerant of string or number input.
 */
export const isUnclassifiableIndustryCode = (value: unknown): boolean => {
  if (value == null || value === '') {
    return false;
  }
  const normalized = String(value).trim();
  return (UNCLASSIFIABLE_INDUSTRY_CODES as readonly string[]).includes(
    normalized
  );
};
